import type { User } from '@/features/auth/auth.service'
import { setActivePanelTimezone, PLATFORM_TIMEZONE } from '@/lib/panel-timezone'
import { resolvePreferredOrganizationId } from '@/lib/resolve-active-organization'

type AuthUserShape = {
  id: string
  user_id?: string
  email: string
  name?: string
  display_name?: string
  role?: string
  roles: string[]
  permissions: string[]
  type: string
  reseller_id?: string
  customer_id?: string
  active_org_id?: string
  readonly?: boolean
  timezone?: string
  whitelabel_enabled?: boolean
  brand_name?: string
  brand_logo_url?: string
  memberships?: User['memberships']
}

export function meToAuthUser(me: User): AuthUserShape {
  const preferredOrgId = resolvePreferredOrganizationId({
    activeOrgId: me.active_org_id,
    memberships: me.memberships,
  })

  setActivePanelTimezone(PLATFORM_TIMEZONE)

  return {
    id: me.user_id,
    user_id: me.user_id,
    role: me.role,
    name: me.display_name,
    display_name: me.display_name,
    email: '',
    roles: [me.role],
    permissions: [],
    type: me.role,
    reseller_id: me.reseller_id,
    customer_id: me.customer_id,
    active_org_id: preferredOrgId ?? undefined,
    readonly: me.readonly === true,
    timezone: PLATFORM_TIMEZONE,
    whitelabel_enabled: me.whitelabel_enabled === true,
    brand_name: me.brand_name?.trim() || undefined,
    brand_logo_url: me.brand_logo_url?.trim() || undefined,
    memberships: me.memberships,
  }
}
